import handleFetchErrors from '../utils/handleFetchErrors';
import { getAccessTokenFromLocalStorage } from '../utils/authHelpers';

const search360BaseUrl = process.env.REACT_APP_SEARCH360_HOST;

const getAccessToken = async (
  oktaCode: string,
  redirectUri: string,
): Promise<{
  access_token: string;
  expires_in: number;
  issued_token_type: string;
  token_type: string;
}> => {
  const response = await fetch(`${search360BaseUrl}/oauth/access_token/v1`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ oktaCode, redirectUri }),
  });

  handleFetchErrors(response);
  return response.json();
};

const getTokenizerAnalysis = async (
  tokenText: string,
  mode: string,
  dicts: string[],
  tokenizations: string[],
) => {
  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${getAccessTokenFromLocalStorage()}`,
  };

  const payload = {
    phrases: [tokenText],
    tokenizeMode: mode,
    dictionaries: dicts,
    explain: 'true',
    englishTokenization: tokenizations.includes('ENGLISH'),
  };
  const response = await fetch(
    `${search360BaseUrl}/proxy/search/tokenizer/v1/tokenize/search`,
    {
      method: 'POST',
      headers,
      body: JSON.stringify(payload),
    },
  );

  handleFetchErrors(response);
  return response.json();
};

const getAdminUserProfile = () =>
  fetch(`${search360BaseUrl}/user/info`, {
    headers: { Authorization: `Bearer ${getAccessTokenFromLocalStorage()}` },
  })
    .then(handleFetchErrors)
    .then((res) => res.json());

const getDictionary = (dictionary: string) =>
  fetch(`${search360BaseUrl}/dictionary/${dictionary}/entry/v1`, {
    headers: {
      Authorization: `Bearer ${getAccessTokenFromLocalStorage()}`,
      'Content-Type': 'application/json',
    },
  })
    .then(handleFetchErrors)
    .then((res) => res.json());

const createDictionaryTerm = async (
  data: DictionaryTermPayload,
  dictionary: string,
) => {
  const response = await fetch(
    `${search360BaseUrl}/dictionary/${dictionary}/entry/v1`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getAccessTokenFromLocalStorage()}`,
      },
      body: JSON.stringify(data),
    },
  );

  handleFetchErrors(response);
  return response.json();
};

const updateDictionaryTerm = async (
  data: Partial<DictionaryTerm>,
  dictionary: string,
) => {
  const id = data.id;
  delete data.id;
  const response = await fetch(
    `${search360BaseUrl}/dictionary/${dictionary}/entry/v1/${id}`,
    {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getAccessTokenFromLocalStorage()}`,
      },
      body: JSON.stringify(data),
    },
  );

  handleFetchErrors(response);
  return response;
};

const delDictionaryTerm = async (id: string, dictionary: string) => {
  const response = await fetch(
    `${search360BaseUrl}/dictionary/${dictionary}/entry/v1/${id}`,
    {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${getAccessTokenFromLocalStorage()}` },
    },
  );

  handleFetchErrors(response);
  return response;
};

export {
  getAccessToken,
  getTokenizerAnalysis,
  getAdminUserProfile,
  getDictionary,
  createDictionaryTerm,
  updateDictionaryTerm,
  delDictionaryTerm,
};
